import React from 'react';
import {Chip, ChipProps} from '@mui/material';

type DefectSeverity = 'LOW' | 'MEDIUM' | 'HIGH' | 'CRITICAL';

interface SeverityBadgeProps {
  severity: DefectSeverity;
  size?: ChipProps['size'];
}

const severityColors: Record<DefectSeverity, {bg: string; text: string}> = {
  CRITICAL: {bg: '#dc3545', text: '#fff'},
  HIGH: {bg: '#ff9800', text: '#fff'},
  MEDIUM: {bg: '#ffc107', text: '#000'},
  LOW: {bg: '#4caf50', text: '#fff'},
};

export function SeverityBadge({severity, size = 'small'}: SeverityBadgeProps) {
  const colors = severityColors[severity] || severityColors.MEDIUM;

  return (
    <Chip
      label={severity}
      size={size}
      sx={{
        backgroundColor: colors.bg,
        color: colors.text,
        fontWeight: 600,
        fontSize: size === 'small' ? '0.7rem' : '0.8rem',
      }}
    />
  );
}
